import axios from 'axios';
import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['titleInput', 'input', 'submitBtn', 'result', 'error'];
  static values = {
    url: String,
    defaultPlaceholder: {
      type: String,
      default: 'List of 20 words that start with the letter B',
    },
  };

  minInputLength = 10;

  initialize() {
    $(this.element).on('show.bs.modal', this.initializeSuggestionsTitle.bind(this));
    $(this.element).on('shown.bs.modal', this.onModalShown.bind(this));
    $(this.element).on('hide.bs.modal', this.resetErrorMessage.bind(this));
  }

  validatePrompt() {
    this.submitBtnTarget.disabled = !this.isValidInputLength;
  }

  onKeydown(event) {
    switch (event.key) {
      case 'Enter':
        event.preventDefault();
        event.stopPropagation();
        if (!this.isValidInputLength) break;

        this.getSuggestions();
        break;
      default:
        break;
    }
  }

  async getSuggestions() {
    this.startLoading();

    try {
      const { data } = await axios.post(this.urlValue, { prompt: this.inputValue });
      const formattedData = data.join('\r\n');
      this.resultTarget.value = formattedData;
      if (this.modalElement) $(this.modalElement).modal('hide');
    } catch (error) {
      this.errorTarget.innerText = error.response?.data?.message;
    } finally {
      this.stopLoading();
    }
  }

  // Private

  initializeSuggestionsTitle() {
    const titleValue = this.titleInputTarget.value.trim();

    if (titleValue) {
      this.inputTarget.value = `List of ${titleValue.replace(/^(List of)?\s?(.*)/i, '$2')}`;
    } else {
      this.inputTarget.value = this.defaultPlaceholderValue;
    }
  }

  onModalShown() {
    this.inputTarget.focus();
    this.validatePrompt();
  }

  startLoading() {
    this.submitBtnTarget.disabled = true;
    this.submitBtnTarget.setAttribute('loading', '');
    this.inputTarget.disabled = true;
    this.resetErrorMessage();
  }

  stopLoading() {
    this.submitBtnTarget.disabled = false;
    this.submitBtnTarget.removeAttribute('loading');
    this.inputTarget.disabled = false;
  }

  resetErrorMessage() {
    this.errorTarget.innerText = '';
  }

  get isValidInputLength() {
    return this.inputValue.length >= this.minInputLength;
  }

  get inputValue() {
    return this.inputTarget.value.trim();
  }

  get modalElement() {
    const modalTrigger = this.element.querySelector('[data-toggle="modal"]');
    if (!modalTrigger) return null;

    const id = modalTrigger.getAttribute('data-target');
    if (!id) return null;

    return document.getElementById(id.substring(1));
  }
}
